import util   from '../../common/AppUtil';

const ServerMode = 1;
const ApiCode = "view";

export default {
  
  execute: function(action,params) {
    return util.callServerPost(ServerMode,ApiCode,params,action);
  },


  getListPage: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"list");
  },

  removeRecord: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"del");
  },

  addRecord: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"add");
  },

  saveRecord: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"save");
  },

  getRecord: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"get");
  }
}
  


// WEBPACK FOOTER //
// ./src/api/bas/view.js